import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { FontWithOutline } from "../../generic/font-with-outline/FontWithOutline";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
export var RecipeWithAmount = function (_a) {
    var cost = _a.cost, product = _a.product, shouldDisplayInputIcon = _a.shouldDisplayInputIcon, onClick = _a.onClick, className = _a.className, unlockLevel = _a.unlockLevel, ownedAmount = _a.ownedAmount, amount = _a.amount, id = _a.id;
    var requirementClass = ownedAmount.greaterThanOrEqual(amount)
        ? IdStyles.TextPositive
        : IdStyles.TextNegative;
    var ownedAmountDisplay = (React.createElement(React.Fragment, null,
        React.createElement(NumberFormat, { amount: ownedAmount, format: TypeNumberFormat.None }),
        "/"));
    var showOwnedAmount = id !== IdResource.Money && id !== IdResource.Gold;
    var resource = shouldDisplayInputIcon ? cost[0] : product[0];
    return (React.createElement("div", { onClick: onClick, className: (className || "") + " " + IdStyles.RecipeItem + " flex flex--guts flex--stacked recipe-with-amount" },
        React.createElement(ResourceIcon, { resource: resource, styleId: IdStyles.IconExtraLarge, unlockLevel: unlockLevel, tooltipVerticalAdjust: IdTooltipAdjust.Small }),
        React.createElement(FontWithOutline, { style: requirementClass },
            showOwnedAmount && ownedAmountDisplay,
            React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.None }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/inventory/recipe/RecipeWithAmount.tsx
// module id = 2241
// module chunks = 3